module.exports = {
      id: "quote-usage",
      viewBox: "0 0 135 109",
      url: __webpack_public_path__ + "img/icons.91580017.svg#quote-usage",
      toString: function () {
        return this.url;
      }
    }